module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_8019.5a41d066.png";